
<template>
    <select :value="value" v-bind="$attrs" :disabled="disabled"  class="form-control vuexaurumselect pointer" @change="selectchanged($event.target.value)">
  <option disabled selected value="" >{{placeholder}}</option>
    <option
    v-for="(listitem,index) in datalist"
      v-bind:value="listitem.value"
      :key="index" >
      {{listitem.labelText}} 
    </option>

  </select>

</template>

<script>

export default {
  name: 'XVdropdown',
  inheritAttrs: false,
  props: {
      focus: {
        type: Boolean,
        default: false
      },
      id: {
        type: String,
        required: true
      },
      datalist: {
        type: Array,
        reuired: true
      },
      value: {
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      formdata: {},
      disabled: {
        type: Boolean,
        default: false
      }
  },
  data: function () {
    return {
        checkedindex: ''
    }
  },
  mounted: function(){
     this.checkedindex = this.value
  },
  methods: {
    selectchanged: function(val){
        let dliobj = this.datalist.filter((v) => { return String(v.value) === String(val) })[0]
        this.$emit('input', val)
        this.$emit('change', val)
        this.$emit('formvaluechanged',
        {
          type: this.$vnode.componentOptions.tag,
          value: dliobj.value,
          labelText: dliobj.labelText,
          id: this.id,
          formdata: this.formdata
        }
      )
    }
  }
}
</script>


<style>
